import React, { useRef, useState } from 'react';
import axios from 'axios';
import { loadWirelessTargets, wirelessAuth, wirelessRecoveryMessage, wirelessTargetForDevice } from './wirelessDebuggingApi';

export default function WirelessDebuggingReconnect({ deviceId, siteId }) {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const running = useRef(false);
  const reconnect = async () => {
    if (running.current) return;
    running.current = true;
    setBusy(true); setMessage('Checking ADB before running the trained recovery…');
    try {
      const target = wirelessTargetForDevice(await loadWirelessTargets(siteId), deviceId);
      if (!target) throw new Error('Wireless Debugging target unavailable. Check Pairing.');
      const response = await axios.post(`/api/site-control/targets/${target.deviceId}/wireless-debugging-routine/reconnect`, {}, { ...wirelessAuth(), timeout: 300000 });
      setMessage(wirelessRecoveryMessage(response.data));
    } catch (error) {
      setMessage(error?.response?.data?.message || error.message || 'Recovery request failed.');
    } finally { running.current = false; setBusy(false); }
  };
  return <>
    <button type="button" className="topology-live__signal" disabled={busy || !siteId}
      title="Run the enabled Wireless Debugging recovery routine over Android TV Remote"
      onClick={reconnect}>{busy ? 'Reconnecting…' : '(Reconnect?)'}</button>
    {message && <span className="topology-live__observation" role="status">{message}</span>}
  </>;
}
